import React from 'react';
import { FormMultiSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useContactOfFilter } from './useContactOfFilter';

export const ContactOfFilter = ({ value, setFilters }) => {
  const { formSchema, options, isLoading, onSubmit, onMenuOpen } = useContactOfFilter({
    setFilters,
  });

  return (
    <Formik
      initialValues={{ importerIds: value || [] }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="importerIds"
          label="Contact of"
          placeholder="Select"
          size="small"
          component={FormMultiSelect}
          options={options}
          onMenuOpen={onMenuOpen}
          isLoading={isLoading}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

ContactOfFilter.propTypes = {
  value: PropTypes.array,
  setFilters: PropTypes.func.isRequired,
};

ContactOfFilter.defaultProps = {
  value: [],
};
